import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../../generic.service';
import { CreatePayNowRequest } from '../../../models/payment/createPayNowRequest';
import { PaymentGatewayResponse } from '../../../models/payment/paymentGatewayResponse.model';
import { TransactionDetailResponse } from '../../../models/payment/transactionDetailResponse.model';
import { RefundRequest, RefundResponse } from '../../../models/payment/refund.model';
import { PaymentStatusRequest } from '../../../models/payment/paymentStatus.model';


@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(private genericService: GenericService) { }

  payNow(request: CreatePayNowRequest): Observable<PaymentGatewayResponse> {
    return this.genericService.post<PaymentGatewayResponse>('paynow', request);
  }

  getTransaction(transactionNumber: string): Observable<TransactionDetailResponse> {
    return this.genericService.get<TransactionDetailResponse>(`transaction/${transactionNumber}`);
  }  

  refundTransaction(request: RefundRequest): Observable<RefundResponse> {
    return this.genericService.post<RefundResponse>('refund', request);
  }

  updatePaymentStatus(request: PaymentStatusRequest): Observable<string> {
    return this.genericService.post<string>('paymentstatus', request);
  }
}


